/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import deserializeActionFilter from 'cio/utils/conditions/deserialize/action';
import { SerializedActionCondition } from 'cio/types/conditions/condition';
import CampaignModel from 'cio/models/campaign';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import { ConditionViewerBackgroundVariant } from 'cio/utils/condition-viewer';
import FiltersService from 'cio/services/filters';

interface CioConditionLabelItemMessageArgs {
  condition: SerializedActionCondition;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
  campaign?: CampaignModel;
  tagName: string;
  backgroundVariant?: ConditionViewerBackgroundVariant;
}

export default class CioConditionLabelItemMessage extends Component<CioConditionLabelItemMessageArgs> {
  @service filters!: FiltersService;

  @computed('args.condition.event.{type,name}')
  get conditionModel() {
    let filter = deserializeActionFilter(this.args.condition);

    if (filter.type === 'output' && this.filters.isBranchMessage(filter.action)) {
      filter.type = this.filters.branchMessageTypes[filter.action!];
    }

    return filter;
  }
}
